import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Template } from '../../models/template';
import { ConfigService } from '@modules/core/services/config.service';
import { Multimedia } from '@modules/shared/models/multimedia';
import { TRANSLATION_SCOPE } from '../../i18n/scope';
import { isSingular } from '@core/utils/string.utils';

@Component({
  selector: 'app-course-template-card',
  templateUrl: './course-template-card.component.html',
  styleUrls: ['./course-template-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourseTemplateCardComponent implements OnInit {
  @Input() template: Template;
  translationScope = TRANSLATION_SCOPE;
  baseUrl: string = '/kursoversikt/';
  readonly isSingular = isSingular;

  constructor(private configService: ConfigService) {
  }

  ngOnInit(): void {
  }

  getDefaultImage(media: Multimedia[]): string {
    if (media.length) {
      return media.find((media) => media.default == true).url;
    } else {
      return this.defaultBanner();
    }
  }

  defaultBanner(): string {
    const env = this.configService.getCurrent().env;

    switch (env) {
      case 'production':
        return 'https://rssjoliv-prod.imgix.net/harbour/harbour_default_banner.png';
      case 'staging':
        return 'https://rssjoliv-staging.imgix.net/harbour/harbour_default_banner.png';
      default:
        return 'https://rssjoliv-dev.imgix.net/harbour/harbour_default_banner.png';
    }
  }
}
